import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Birthday from 'features/account/PersonalInfo/Birthday';
import wineIcon from 'features/shop/AgeValidationModal/wineIcon';
import Modal from 'honeydew/Modal';
import { calculateAge } from 'utils/birthdayUtils';

export function useAgeValidationModal({ subscription }) {
    const [isAgeValidationModalOpen, setIsAgeValidationModalOpen] = useState(false);
    const { dateOfBirth } = subscription ?? {};
    const under21 = calculateAge(dateOfBirth) < 21;

    useEffect(() => {
        if (dateOfBirth && !under21) {
            setIsAgeValidationModalOpen(false);
        }
    }, [dateOfBirth, under21]);

    return {
        isAgeValidationModalOpen,
        setIsAgeValidationModalOpen,
    };
}

function AgeValidationModal({ birthday, customerID, modalOpen, setModalOpen, subscriptionID }) {
    return (
        <Modal
            open={modalOpen}
            onClose={() => setModalOpen(false)}
            headline="Enter your birthday"
            centered
            icon={<div className="mb-15">{wineIcon}</div>}
        >
            <div className="mb-50">
                <p className="text-center">You must be 21+ to purchase this item.</p>
                <p className="mb-20 text-center">Valid ID required at delivery.</p>
                <Birthday
                    customerID={customerID}
                    subscriptionID={subscriptionID}
                    birthday={birthday}
                    onClickHandler={() => setModalOpen(false)}
                    continueCtaCopy
                    editingMode
                    validateDrinkingAge
                />
            </div>
        </Modal>
    );
}

AgeValidationModal.propTypes = {
    birthday: PropTypes.string,
    customerID: PropTypes.number,
    modalOpen: PropTypes.bool.isRequired,
    setModalOpen: PropTypes.func.isRequired,
    subscriptionID: PropTypes.number,
};

AgeValidationModal.defaultProps = {
    birthday: null,
    customerID: null,
    subscriptionID: null,
};

export default AgeValidationModal;
